import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-hphtrheology-vertical',
  standalone: false,
  templateUrl: './hphtrheology-vertical.component.html',
  styleUrl: '../../job-request-column-report.component.scss'
})
export class HphtrheologyVerticalComponent {
@Input() hphtrheologyTest:any;

}
